import LocalStorageProviderSingleton from './local_storage_provider_singleton'
import SessionStorageProviderSingleton from './session_storage_provider_singleton'
import { STORAGE_TYPE_SESSION, STORAGE_TYPE_LOCAL } from '../config'

class StorageProviderFactory {
  /**
   * factory to create instance of StorageProvider type
   * @param type
   * @return StorageProvider
   */
  static create(type) {
    switch (type.toLowerCase()) {
      case STORAGE_TYPE_SESSION:
        return SessionStorageProviderSingleton.getInstance()
      case STORAGE_TYPE_LOCAL:
        return LocalStorageProviderSingleton.getInstance()
      default:
        throw new Error('Unknown type of session storage requested')
    }
  }
}

export default StorageProviderFactory
